export default __webpack_public_path__ + "static/media/logo-swissmarkets-white.cf4fef1c.svg";